import { jsxs as x, jsx as t } from "react/jsx-runtime";
import * as d from "@radix-ui/react-menu";
import { useControllableState as C } from "@radix-ui/react-use-controllable-state";
import { RefToTgphRef as g } from "@telegraph/helpers";
import { Stack as b, Box as I } from "@telegraph/layout";
import v from "react";
import { Button as p } from "@telegraph/button";
import { Lucide as O } from "@telegraph/icon";
import { motion as w } from "@telegraph/motion";
const R = ({
  variant: n = "ghost",
  size: e = "2",
  h: r = "7",
  gap: o = "3",
  justify: i = "space-between",
  w: a = "auto",
  selected: c,
  icon: s,
  leadingIcon: u,
  leadingComponent: l,
  trailingIcon: f,
  trailingComponent: h,
  ...m
}) => /* @__PURE__ */ x(
  p.Root,
  {
    size: e,
    variant: n,
    h: r,
    gap: o,
    justify: i,
    w: a,
    ...m,
    children: [
      /* @__PURE__ */ x(b, { gap: o, align: "center", w: "full", children: [
        /* @__PURE__ */ t(
          B,
          {
            icon: s,
            selected: c,
            leadingIcon: u,
            leadingComponent: l
          }
        ),
        /* @__PURE__ */ t(
          p.Text,
          {
            weight: "regular",
            w: "full",
            overflow: "hidden",
            textOverflow: "ellipsis",
            children: m.children
          }
        )
      ] }),
      /* @__PURE__ */ t(
        M,
        {
          trailingIcon: f,
          trailingComponent: h
        }
      )
    ]
  }
), B = ({
  icon: n,
  selected: e,
  leadingIcon: r,
  leadingComponent: o
}) => {
  if (e === !0 || e === !1)
    return /* @__PURE__ */ t(
      p.Icon,
      {
        as: w.span,
        variant: "primary",
        icon: O.Check,
        "aria-hidden": !0,
        initializeWithAnimation: !1,
        animate: e ? {
          opacity: 1,
          rotate: 0,
          scale: 1
        } : {
          opacity: 0,
          rotate: -45,
          scale: 0.3
        },
        transition: { duration: 150, type: "spring" },
        style: { transformOrigin: "center" },
        display: "block"
      }
    );
  const a = r || n;
  if (a)
    return /* @__PURE__ */ t(p.Icon, { variant: "primary", ...a });
  if (o)
    return o;
}, M = ({
  trailingIcon: n,
  trailingComponent: e
}) => {
  if (n)
    return /* @__PURE__ */ t(p.Icon, { variant: "primary", ...n });
  if (e)
    return e;
}, y = v.createContext({
  open: !1,
  setOpen: () => {
  }
}), k = ({
  open: n,
  onOpenChange: e,
  defaultOpen: r,
  modal: o = !0,
  children: i,
  ...a
}) => {
  const [c = !1, s] = C({
    prop: n,
    defaultProp: r,
    onChange: e
  });
  return /* @__PURE__ */ t(y.Provider, { value: { open: c, setOpen: s }, children: /* @__PURE__ */ t(
    d.Root,
    {
      open: c,
      onOpenChange: s,
      modal: o,
      ...a,
      children: i
    }
  ) });
}, S = ({ asChild: n = !0, tgphRef: e, children: r, ...o }) => {
  const i = v.useContext(y);
  return /* @__PURE__ */ t(
    d.Anchor,
    {
      onClick: () => {
        i.setOpen(!i.open);
      },
      asChild: n,
      ...o,
      ref: e,
      children: /* @__PURE__ */ t(g, { children: r })
    }
  );
}, T = ({
  direction: n = "column",
  gap: e = "1",
  rounded: r = "4",
  py: o = "1",
  border: i = "px",
  shadow: a = "2",
  sideOffset: c = 4,
  children: s,
  onInteractOutside: u,
  onKeyDown: l,
  onCloseAutoFocus: f,
  tgphRef: h,
  ...m
}) => /* @__PURE__ */ t(
  d.Content,
  {
    onInteractOutside: u,
    onKeyDown: l,
    onCloseAutoFocus: f,
    asChild: !0,
    sideOffset: c,
    ...m,
    ref: h,
    children: /* @__PURE__ */ t(g, { children: /* @__PURE__ */ t(
      b,
      {
        bg: "surface-1",
        direction: n,
        gap: e,
        rounded: r,
        border: i,
        py: o,
        shadow: a,
        style: {
          overflowY: "auto"
        },
        zIndex: "popover",
        children: s
      }
    ) })
  }
), L = ({
  mx: n = "1",
  asChild: e = !0,
  icon: r,
  leadingIcon: o,
  trailingIcon: i,
  leadingComponent: a,
  trailingComponent: c,
  selected: s,
  tgphRef: u,
  ...l
}) => {
  const f = o || r;
  return /* @__PURE__ */ t(d.Item, { ...l, asChild: e, ref: u, children: /* @__PURE__ */ t(g, { children: /* @__PURE__ */ t(
    R,
    {
      selected: s,
      leadingIcon: f,
      trailingIcon: i,
      leadingComponent: a,
      trailingComponent: c,
      "data-tgph-menu-button": !0,
      mx: n,
      style: {
        flexShrink: 0
      },
      ...l
    }
  ) }) });
}, j = ({
  w: n = "full",
  borderBottom: e = "px",
  ...r
}) => /* @__PURE__ */ t(I, { as: "hr", w: n, borderBottom: e, ...r }), z = {};
Object.assign(z, {
  Root: k,
  Trigger: S,
  Content: T,
  Button: L,
  Divider: j
});
export {
  z as Menu,
  R as MenuItem
};
//# sourceMappingURL=index.mjs.map
